<div class="kr-spinner"><div class="kr-bounce1"></div><div class="kr-bounce2"></div><div class="kr-bounce3"></div></div>